import { Subtitle1 } from '@fluentui/react-components';
import React from 'react';
import { AppState, useClasses } from '../../App';
import GHSLogo from '../../ghs-logo-circle.svg';
import { AuthHelper } from '../../libs/auth/AuthHelper'; // (minor: removed double slash)
import { useRole } from '../../libs/hooks';
import { UserSettingsMenu } from '../header/UserSettingsMenu';
import { PluginGallery } from '../open-api-plugins/PluginGallery';
import { BackendProbe, ChatView, Error, Loading } from '../views';
import { NotAuthorized } from '../views/NotAuthorized';

const Chat = ({
    classes,
    appState,
    setAppState,
}: {
    classes: ReturnType<typeof useClasses>;
    appState: AppState;
    setAppState: (state: AppState) => void;
}) => {
    const { hasRole, hasAnyRole } = useRole();

    // ✅ Call hooks unconditionally
    const onBackendFound = React.useCallback(() => {
        setAppState(AuthHelper.isAuthAAD() ? AppState.SettingUserInfo : AppState.LoadChats);
    }, [setAppState]);

    if (!hasAnyRole(['GlobalAdmin', 'GenGPTAccess'])) {
        return (
            <NotAuthorized text="You do not have the necessary permissions to access this page. GenGPT is not available to the organization at this time." />
        );
    }

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <span className={classes.logoDiv}>
                    <img src={GHSLogo} className={classes.logo} alt="GHS Logo" />
                    <Subtitle1 as="h1">GenGPT</Subtitle1>
                </span>
                {appState > AppState.SettingUserInfo && (
                    <div className={classes.cornerItems}>
                        <div className={classes.cornerItems}>
                            <a
                                href="https://forms.office.com/pages/responsepage.aspx?id=ySJtiaQieEWALoJ8JIY3dq4AyDr_bndDlTLwBPa4KftUNzlKV1RJWUNISU9DR01PWE42V1FCMVpYWi4u&route=shorturl"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    backgroundColor: '#0078D4',
                                    color: 'white',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    transition: 'background-color 0.2s ease',
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#005A9E')}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#0078D4')}
                            >
                                💬 We’d love your feedback!
                            </a>

                            {hasRole('GlobalAdmin') && <PluginGallery />}
                            <UserSettingsMenu
                                setLoadingState={() => {
                                    setAppState(AppState.SigningOut);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>

            {appState === AppState.ProbeForBackend && <BackendProbe onBackendFound={onBackendFound} />}
            {appState === AppState.SettingUserInfo && <Loading text="Hang tight while we fetch your information..." />}
            {appState === AppState.ErrorLoadingUserInfo && (
                <Error text="Unable to load user info. Please try signing out and signing back in." />
            )}
            {appState === AppState.ErrorLoadingChats && (
                <Error text="Unable to load chats. Please try refreshing the page." />
            )}
            {appState === AppState.LoadingChats && <Loading text="Loading chats..." />}
            {appState === AppState.Chat && <ChatView />}
        </div>
    );
};

export default Chat;
